export default {
      id: "button-icon-save-usage",
      viewBox: "0 0 15 15.04",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#button-icon-save",
      toString: function () {
        return this.url;
      }
    }